<template>
    <!-- Marketing -->
    <SectionWrapper v-if="!settings.is_sourcing_mode">
        <template #title>
            <span class="at1024:flex at1024:flex-col at1024:items-start">Shipping &amp; Delivery<span class="sr-only">:</span>
                <span class="font-normal ml-2 text-gray text-base at1024:ml-0">
                    {{ computedDeliveredCount }} of {{ Object.keys(shipments).length }} delivered
                </span>
            </span>
        </template>
        <template #default>
            <ul class="space-y-2 at1024:space-y-4">
                <TrackingCard
                    v-for="shipment in shipments"
                    :to-city="shipment.destination?.city"
                    :to-state="shipment.destination?.state_province"
                    :from-city="shipment.origin?.city"
                    :from-state="shipment.origin?.state_province"
                    :status-description="getStatusResponse(shipment.status?.text,
                        shipment.status?.text && shipment.status?.text?.toLowerCase() === 'delivered'
                            ? shipment.delivery_date
                            : shipment.estimated_delivery ?? null
                    )?.message"
                    :status="shipment.status?.text"
                    :tracking-number="shipment.tracking_number"
                    :seclock-position="getPercentageComplete(shipment, order)"
                    :estimated-delivery="shipment.estimated_delivery"
                    :date-shipped="order.shipments.data.find(ship => ship.tracking_number === shipment.tracking_number)?.date ?? null"
                    :delivery-date="shipment.delivery_date"
                    :tracking-url="shipment.tracking_link"
                    :updated-at="shipment.updated_at"
                    :is-large="true"
                    :order="order"
                />
            </ul>
        </template>
    </SectionWrapper>

    <!-- Sourcing Mode -->
    <div v-if="settings.is_sourcing_mode" class="mb-6">
        <div v-if="computedDeliveredCount" class="font-normal pb-2 text-sm">
            <strong>{{ computedDeliveredCount }}</strong> of <strong>{{ Object.keys(shipments).length }}</strong> delivered
        </div>

        <ul class="space-y-6">
            <TrackingCard
                v-for="shipment in shipments"
                :to-city="shipment.destination?.city"
                :to-state="shipment.destination?.state_province"
                :from-city="shipment.origin?.city"
                :from-state="shipment.origin?.state_province"
                :status-description="getStatusResponse(shipment.status?.text,
                    shipment.status?.text && shipment.status?.text?.toLowerCase() === 'delivered'
                        ? shipment.delivery_date
                        : shipment.estimated_delivery ?? null
                )?.message"
                :status="shipment.status?.text"
                :tracking-number="shipment.tracking_number"
                :seclock-position="getPercentageComplete(shipment, order)"
                :estimated-delivery="shipment.estimated_delivery"
                :date-shipped="order.shipments.data.find(ship => ship.tracking_number === shipment.tracking_number)?.date ?? null"
                :delivery-date="shipment.delivery_date"
                :tracking-url="shipment.tracking_link"
                :updated-at="shipment.updated_at"
                :is-large="true"
                :order="order"
            />
        </ul>
    </div>
</template>

<script setup>
import {TrackingCard, SectionWrapper} from "@/Themes/Marketing";
import {useShipping, useUser} from "@/Composables";
import {computed} from "vue";
import _ from 'lodash';

const props = defineProps(['shipments', 'order']);

const { getPercentageComplete, getStatusResponse } = useShipping();
const { settings } = useUser();

const computedDeliveredCount = computed(() => {
    let shipments = Object.values(props.shipments);

    let statuses = _.flatMap(shipments, 'status.text');

    return _.filter(statuses, status => status && status.toLowerCase() === 'delivered')?.length;
});

</script>
